import{gql as t}from"@apollo/client";const o=t`
  mutation hasSeenSpotlight($url: String!) {
    user {
      hasSeenSpotlight(url: $url)
    }
  }
`;export{o as HAS_SEEN_SPOTLIGHT};
//# sourceMappingURL=useHasSeenSpotlight.graphql.js.map
